import React from 'react';

import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import CheckboxInput from 'ui-library/inputs/CheckboxInput';
import {InputChangeEvent} from 'util/Types';

export default function WorksheetRunCheckbox(props: {
  isSkipChecked: boolean;
  onChangeSkipCheckbox: (checkbox: boolean) => void;
  checkboxLabel: string;
}): JSX.Element {
  return (
    <FormGroup>
      <Label>Bulk step update</Label>
      <CheckboxInput
        onChange={(e: InputChangeEvent) => {
          props.onChangeSkipCheckbox(e.target.checked);
        }}
        checked={props.isSkipChecked}
        id="worksheets-complete-run-checkbox"
        label={props.checkboxLabel}
        dataTestAttrs={{
          component: 'WorksheetRunCheckbox',
          element: 'checkbox',
        }}
      />
    </FormGroup>
  );
}
